import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './store';
import { BrowserRouter } from 'react-router-dom';  // Keep BrowserRouter here

const root = ReactDOM.createRoot(document.getElementById('root'));
// window.getPublicUrl = (path) => `/Users/enacteservices/Desktop/snf_new_frontend/public/${path}`;   
// window.getPublicUrl = (path) => `${path}`;

window.getPublicUrl = (path) => `${process.env.REACT_APP_PUBLIC_URL}/${path}`;
root.render(
  <Provider store={store}>
    <BrowserRouter>  {/* BrowserRouter here */}
      <App />
    </BrowserRouter>
  </Provider>
);

reportWebVitals();
